import React from 'react';

import SocialAccountPage from './SocialAccountPage';

export default function MicrosoftSocialAccount() {
  return <SocialAccountPage type="MICROSOFT" />;
}
